import React from "react";
import { SectionTitle } from "./SubscriptionPage.styles";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ViewMoreBankTransfers from "../../../components/Subscriptions/ViewMoreBankTransfers";

import { selectedLocale } from "../../../store/slices/common/slice";
import { useSelector } from "react-redux";

const BankTransfersPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  return (
    <>
      <SectionTitle>{t("subscriptions")}</SectionTitle>

      <ViewMoreBankTransfers
        ar={ar}
        onBack={() => navigate("/admin-portal/subscriptions")}
      />
    </>
  );
};

export default BankTransfersPage;
